import { Inject, Injectable, computed, signal } from '@angular/core';
import { DOCUMENT } from '@angular/common';

/**
 * TODO:
 * Add typing for locales
 */

@Injectable({ providedIn: 'root' })
export class HtmlLang {
    currentLang = signal<string>('en-US');
    availableLangs = signal<string[]>([]);
    selectableLangs = computed(() =>
        this.availableLangs().filter((lang) => lang !== this.currentLang()),
    );

    constructor(@Inject(DOCUMENT) private readonly document: Document) {}

    setHtmlLang(lang: string) {
        this.document.documentElement.lang = lang;
        this.currentLang.set(lang);
    }

    setAvailableLangs(langs: string[]) {
        this.document.documentElement.setAttribute(
            'data-langs',
            langs.join(','),
        );
        this.availableLangs.set(langs);
    }
}
